import { promiseAction } from 'utils/store';

export const JJ_FORTUNE_ACTION_TYPES = {
  LOAD_JJ_LIKES_STEP_RANGES: 'jjFortune/LOAD_JJ_LIKES_STEP_RANGES',
  CREATE_JJ_LIKES_STEP_VALUE: 'jjFortune/CREATE_JJ_LIKES_STEP_VALUE',
  DELETE_JJ_LIKES_STEP_VALUE: 'jjFortune/DELETE_JJ_LIKES_STEP_VALUE',
  LOAD_JJ_FORTUNE_AVAILABILITY_SETTINGS: 'jjFortune/LOAD_JJ_FORTUNE_AVAILABILITY_SETTINGS',
  EDIT_JJ_FORTUNE_AVAILABILITY_SETTINGS: 'jjFortune/EDIT_JJ_FORTUNE_AVAILABILITY_SETTINGS',
  LOAD_JJ_FORTUNE_PAYOUTS: 'jjFortune/LOAD_JJ_FORTUNE_PAYOUTS',
  EDIT_JJ_FORTUNE_PAYOUT: 'jjFortune/EDIT_JJ_FORTUNE_PAYOUT',
  LOAD_JOY_JET_INCOME: 'jjFortune/LOAD_JOY_JET_INCOME',
  IMPORT_JOY_JET_INCOME: 'jjFortune/IMPORT_JOY_JET_INCOME',
  ADD_JJ_COINS_USER: 'jjFortune/ADD_JJ_COINS_USER',
};

export const loadJJLikesStepRangesAction = promiseAction(JJ_FORTUNE_ACTION_TYPES.LOAD_JJ_LIKES_STEP_RANGES);
export const createJJLikesStepValueAction = promiseAction(JJ_FORTUNE_ACTION_TYPES.CREATE_JJ_LIKES_STEP_VALUE);
export const deleteJJLikesStepValueAction = promiseAction(JJ_FORTUNE_ACTION_TYPES.DELETE_JJ_LIKES_STEP_VALUE);
export const loadJJFortuneAvailabilitySettingsAction = promiseAction(JJ_FORTUNE_ACTION_TYPES.LOAD_JJ_FORTUNE_AVAILABILITY_SETTINGS);
export const editJJFortuneAvailabilitySettingsAction = promiseAction(JJ_FORTUNE_ACTION_TYPES.EDIT_JJ_FORTUNE_AVAILABILITY_SETTINGS);
export const loadJJFortunePayoutsAction = promiseAction(JJ_FORTUNE_ACTION_TYPES.LOAD_JJ_FORTUNE_PAYOUTS);
export const editJJFortunePayoutAction = promiseAction(JJ_FORTUNE_ACTION_TYPES.EDIT_JJ_FORTUNE_PAYOUT);
export const loadJoyJetIncomeAction = promiseAction(JJ_FORTUNE_ACTION_TYPES.LOAD_JOY_JET_INCOME);
export const importJoyJetIncomeAction = promiseAction(JJ_FORTUNE_ACTION_TYPES.IMPORT_JOY_JET_INCOME);
export const addJJCoinsUserAction = promiseAction(JJ_FORTUNE_ACTION_TYPES.ADD_JJ_COINS_USER);